import { useMutation } from "@tanstack/react-query";
import { toast } from "react-toastify";
import { videoService } from "../../../services/video";
import { convertHeightToInches } from "../utils/convertHeightToInches";
import { useInvalidate } from "../../../hooks/useInvalidate";

export function useAnalyzeVideos() {
  const invalidate = useInvalidate();

  return useMutation({
    mutationFn: async (videos) => {
      try {
        await Promise.all(
          videos.map((video) =>
            videoService.sendAnalysisVideoRequest({
              metaData: {
                clubId: video.userData.golfClub,
                fps: video.metaData.fps,
                gender: video.userData.gender.toUpperCase(),
                heightInInches: video.userData.heightInInches
                  ? video.userData.heightInInches
                  : convertHeightToInches(video.userData.height),
                intrinsic: video.metaData.intrinsic,
                swingAngle: video.metaData.cameraAngle,
                swingIsLeftHanded: video.userData.hand.toLowerCase() === "left",
              },
              videoId: video.id,
              videoUrl: video.videoPath,
            })
          )
        );
      } catch (error) {
        console.error("Error analyzing videos:", error);
        const msg = error?.message || "Failed to analyze videos";
        toast.error(msg);
        throw error;
      }
    },
    onError: (error) => {
      const msg = error?.message || "An error occurred while analyzing videos";
      toast.error(msg);
    },
    onSuccess: async () => {
      await invalidate(["getSwingList_key"]);
      toast.success("Videos analyzed successfully");
    },
  });
}
